export default "__VITE_ASSET__UnOfOE2T__"